import * as React from 'react';
import { useState } from 'react';
import { Modal, Typography, Stack, Button, Box } from '@mui/material';
import ArrowRight from '../icons/ArrowRight';
import EduzinhoFigure from './EduzinhoFigure';

type PropsType = {
  open: boolean;
  handleClose: () => void;
};

const FirstAccessModalPanel: React.FC<PropsType> = ({
  open,
  handleClose,
}) => {
  const [stepFirstAccess, setStepFirstAccess] = useState(2);

  const alignButton = () => {
    switch (stepFirstAccess) {
      case 1:
      case 2:
      case 3:
      case 4:
      case 5:
      case 6:
        return 'center';
        break;
      case 7:
      case 8:
        return 'end';
        break;
      default:
        return 'center';
    }
  };

  const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    maxWidth: stepFirstAccess === 9 ? '920px' : '517px',
    width: '100%',
    bgcolor: '#fff',
    borderRadius: '20px',
  };

  return (
    <div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Box style={{ background: '#93DC3F', borderRadius: '20px 20px 0 0', boxShadow: '0px 4px 4px 0px #00000040' }}>
            <Typography color={'#231F20'} variant="h1" p={'10px 29px'}>
              Primeiro acesso
            </Typography>
          </Box>
          <Stack sx={{ p: '20px 30px 50px 30px' }} justifyContent={'center'} alignItems={alignButton()}>
            <Box>
            <EduzinhoFigure message={<p>Olá, eu sou <span style={{color: '#15AB51', fontWeight: 'bold'}}>Eduzinho</span> esse é o seu primeiro acesso ao painel? clique na turma para cadastrar a capacidade. </p>} position={'center'}  />
            </Box>
              <Button
                sx={{  p: '15.5px 50px', borderRadius: '24px', fontSize: '14px', mt: '60px', bgcolor: '#15AB51' }}
                variant="contained"
                onClick={handleClose}
              >
                Cadastrar capacidade das turmas
                <ArrowRight style={{ marginLeft: '10px' }} />
              </Button>
          </Stack>
        </Box>
      </Modal>
    </div>
  );
};

export default FirstAccessModalPanel;
